/** @file Utility functions and constants for the Vue router. */
import { always } from 'purify-ts';
import { Maybe } from '@codegrade/maybe';
/**
 * Extracts the `default` export from a dynamic import result.
 *
 * @param data The imported module.
 * @returns The default export of the module.
 */
export const getDefault = (data) => data.default;
/** A student view getter that always returns Nothing, used for pages with no student view. */
export const NO_STUDENT_VIEW = always(Maybe.empty());
/**
 * Takes an array of route configuration objects and makes them immutable by freezing each one,
 * including their nested 'meta' properties.
 *
 * @param routes An array of route configuration objects.
 * @returns An array of the same route configuration objects, but each made immutable.
 */
export function freezeRoutes(routes) {
    return routes.map(route => {
        Object.freeze(route.meta);
        return Object.freeze(route);
    });
}
/**
 * Student view getter that redirects to the course assignments page.
 *
 * @param route The current route.
 * @returns A student view to the course assignments page.
 */
export const STUDENT_VIEW_ASSIGNMENTS = route => Maybe.of({
    location: {
        name: 'course_assignments',
        params: {
            courseId: route.params.courseId,
        },
        query: {},
    },
    courseId: parseInt(route.params.courseId, 10),
});
/**
 * Student view getter that redirects to the assignment submissions page.
 *
 * @param route The current route.
 * @returns A student view to the assignment submissions page.
 */
export const STUDENT_VIEW_SUBMISSIONS = route => Maybe.of({
    location: {
        name: 'assignment_submissions',
        params: {
            courseId: route.params.courseId,
            assignmentId: route.params.assignmentId,
        },
        hash: '#student-start',
        query: {},
    },
    courseId: parseInt(route.params.courseId, 10),
});
